import Modal from "../Modal";
import { useMutation, useQuery } from "@apollo/client";
import { GET_USER, LOGIN } from "../../../graphql/auth";
import GInput from "../base/GInput";
import GCheckbox from "../base/GCheckbox";
import GButton from "../base/GButton";
import { useState } from "react";
import useMainStore from "../../../store/mainState";
import { CLAIM_DAILY_BONUS } from "../../../graphql/bonuses";
import { useTranslation } from "react-i18next";

interface DailyPopupProps {
    isOpen: boolean;
    onClose: () => void;
    isEligable: boolean;
    reason?: string;
}

const DailyPopup = ({ isOpen, onClose, isEligable, reason }: DailyPopupProps) => {
    const { t } = useTranslation();
    const { setIsLoading } = useMainStore();
    const [claimDailyBonus] = useMutation(CLAIM_DAILY_BONUS)


    const onClaimDailyBonus = async () => {
        if (!isEligable){
            onClose()
            return;
        }
        setIsLoading(true);
        try {
            const { data } = await claimDailyBonus();
        } catch (error) {
            console.log(error);
        }
        onClose()
        setIsLoading(false);
    }
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={t('popup.dailyBonusTitle')} subTitle={t('popup.dailyBonusSubtitle')}>
            {isEligable ? (
                <div className="flex items-center justify-center flex-col w-full ">
                    <img
                        src={require("../../../assets/images/pngtree.png")}
                        className="object-contain m-[0 auto]"
                        alt="Level Up Bonus"
                    width={250}
                    height={250}
                />
                <p className="text-[#fff] md:text-[20px] text-[16px] font-[800] text-center m-[20px]">1 USD</p>
                <GButton className="w-full py-[20px] " onClick={onClaimDailyBonus} isGradient={true}>{t('popup.claim')}</GButton>
            </div>
            ) : (
                <div className="flex items-center justify-center flex-col w-full ">
                   <p className="text-[#fff] text-[20px] font-[800] text-center m-[20px]">{reason || t('popup.dailyOnceADay')}</p>
                <GButton className="w-full py-[20px] " onClick={onClaimDailyBonus} isGradient={true}>{t('popup.ok')}</GButton>
            </div>
            )}
        </Modal>
    )
}

export default DailyPopup